import { InsuranceMonitor } from "@wingspanhq/wingspan-api-sdk";

import {
  RequirementContextType,
  RequirementTableItemData
} from "../../../../types";

import { getInsuranceCoverageRequirementStatus } from "./getInsuranceCoverageRequirementStatus";

export const getInsuranceCoveragePayerRequirementStatus = (
  requirement: RequirementTableItemData,
  insuranceMonitor: InsuranceMonitor | undefined
) => {
  return getInsuranceCoverageRequirementStatus(
    requirement,
    insuranceMonitor,
    RequirementContextType.Payer
  );
};
